var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19 16.75H5A1.76 1.76 0 0 1 3.25 15V5A1.76 1.76 0 0 1 5 3.25h14A1.76 1.76 0 0 1 20.75 5v10A1.76 1.76 0 0 1 19 16.75Zm-14-12a.25.25 0 0 0-.25.25v10a.25.25 0 0 0 .25.25h14a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15 20.75h-3a.76.76 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v3.25H15a.75.75 0 0 1 0 1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12 20.75H9a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.06a551ffc9edb4481dde4fdcae34d7d5.svg";
export { ForwardRef as ReactComponent };